// extracted by mini-css-extract-plugin
export var storyRowWrapperCenter = "B_vS d_bD";
export var storyRowWrapper = "B_hx d_hx d_bK";
export var storyLeftWrapper = "B_vT d_bz d_bP";
export var storyWrapperFull = "B_vV d_cD";
export var storyWrapperFullLeft = "B_pl d_cD d_bz d_bP d_bD";
export var contentWrapper = "B_mS d_hy";
export var storyLeftWrapperCenter = "B_vW d_hz d_bz d_bD d_bP d_bJ";
export var storyRightWrapperCenter = "B_vX d_hF";
export var storyHeader = "B_vY d_hD d_w d_cs";
export var storyHeaderCenter = "B_hC d_hC d_w d_cs d_dw d_by";
export var storyParagraphCenter = "B_hB d_hB d_by d_dw";
export var storyBtnWrapper = "B_vZ d_d2 d_d1 d_w d_bz d_bG";
export var storyBtnWrapperCenter = "B_hJ d_hJ d_d1 d_w d_bz d_bD";
export var imageWrapper = "B_qy d_fg d_Z";
export var imageWrapperFull = "B_q2 d_w d_H d_bf d_Z";
export var SubtitleSmall = "B_qd s_qd s_r2 s_sd";
export var SubtitleNormal = "B_qf s_qf s_r2 s_sf";
export var SubtitleLarge = "B_qg s_qg s_r2 s_sg";
export var textLeft = "B_dv";
export var textCenter = "B_dw";
export var textRight = "B_dx";